import { useSnackbar } from 'notistack';
import { useApi } from '../../shared/context';
import { DealReducedFeeLender } from '../../shared/models';
import { useMutation, useQueryClient } from 'react-query';
import { getResponseData } from '../../shared/utils/axios';
import { CerebroApiEndpoints } from '../../shared/utils/api';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { CerebroTextButton } from '../../shared/components';
import { QueryKeys } from '../../shared/hooks';

interface DeleteReducedFeeLenderDialogProps {
	dealGuid: string | undefined;
	lender: DealReducedFeeLender | null;
	close: () => void;
}

export const DeleteReducedFeeLenderDialog: React.FC<DeleteReducedFeeLenderDialogProps> = ({
	dealGuid,
	lender,
	close,
}) => {
	const api = useApi();
	const snackbar = useSnackbar();
	const client = useQueryClient();

	const onDeleteConfirmation = () => {
		if (lender !== null) deleteReducedFeeLender(lender);
	};

	const { mutate: deleteReducedFeeLender } = useMutation<void, unknown, DealReducedFeeLender>(
		lenderToDelete =>
			getResponseData(
				api.delete<void>(CerebroApiEndpoints.ReducedFeeLenders.Specific(dealGuid, lenderToDelete.guid))
			),
		{
			onMutate: () => {
				close();
			},
			onSuccess: () => {
				client.invalidateQueries(QueryKeys.ReducedFeeLenders(dealGuid));
				snackbar.enqueueSnackbar('Reduced fee lender successfully deleted.', { variant: 'success' });
				close();
			},
			onError: () => {
				snackbar.enqueueSnackbar('There was a problem deleting the reduced fee lender.', {
					variant: 'error',
				});
			},
		}
	);

	return (
		<Dialog open={lender !== null} onClose={close}>
			<DialogTitle>Confirm Delete</DialogTitle>
			<DialogContent>
				<DialogContentText>Are you sure you want to delete {lender?.bankName}?</DialogContentText>
			</DialogContent>
			<DialogActions>
				<CerebroTextButton onClick={close}>No</CerebroTextButton>
				<CerebroTextButton onClick={onDeleteConfirmation}>Yes</CerebroTextButton>
			</DialogActions>
		</Dialog>
	);
};
